/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IModelosTecnicosRepository } from "@/interface/modelos";

const fixasRepository: IModelosTecnicosRepository = {
  /**
   * Função para buscar fixas tecnicas
   * @param accessToken
   * @returns Promise<any | null>
   */
  async getAllModelos<T>(
    accessToken: string,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const modelos = await Instance.get(
      `/modelo-tecnico?per_page=${itemsPerPage}&order=desc&search=${searchItem}&page=${currentPage}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return modelos?.data;
  },

  async getAllModelosPorCliente<T>(
    accessToken: string,
    user_cliente_id = 1,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = "",
    incluirInativos = false
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const modelos = await Instance.get(
      `/modelo-tecnico/clientes/${user_cliente_id}/?per_page=${itemsPerPage}&search=${searchItem}&page=${currentPage}${incluirInativos ? "&incluir_inativos=1" : ""}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return modelos?.data;
  },

  async getModeloUnicoDoCliente<T>(
    accessToken: string,
    modelo_id = 1,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const modelos = await Instance.get(
      `/modelo-tecnico/cliente/unico/${modelo_id}/?per_page=${itemsPerPage}&search=${searchItem}&page=${currentPage}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return modelos?.data;
  },
  async criarNovoModelo(accessToken, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.post(`modelo-tecnico`, payload, {
      headers: {
        // "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },

  async atualizarModelo(accessToken, modelo_id, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.post(`modelo-tecnico/${modelo_id}`, payload, {
      headers: {
        // "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },

  async inativarModelo(accessToken, modelo_id) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const modeloInativado = await Instance.patch(
      `modelo-tecnico/${modelo_id}/inativar`,
      {},
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return modeloInativado?.data;
  },

  async reativarModelo(accessToken, modelo_id) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const modeloReativado = await Instance.patch(
      `modelo-tecnico/${modelo_id}/reativar`,
      {},
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return modeloReativado?.data;
  },
  async criarCamposVariaveisModelo(accessToken, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.post(`modelos-tecnicos-campos-variaveis`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },
};

/**
 * EXPORTS
 */
export { fixasRepository };
